// extracted by mini-css-extract-plugin
export var columns = "DLfHcHvD";
export var column = "_0sQseKKU";